import { useLocation } from 'react-router-dom';

import { IInternalDetailsLocationState } from 'types/global';
import { parseInitialTabFromLocation } from 'utils/parseInitialTabFromLocation';

/**
 * Tab inicial de internas con tabs (orden, SL).
 * Prioriza location.state (history.push); si no hay state, lee ?initialTab (p. ej. enlaces directos a la interna).
 */
const useDetailsInitialTab = (defaultTab: number): number => {
  const location = useLocation<IInternalDetailsLocationState>();
  return parseInitialTabFromLocation(location.search, location.state?.initialTab, defaultTab);
};

export default useDetailsInitialTab;
